import React from "react";

function ProgressUploader({
  label,
  percentage,
}: {
  label: string;
  percentage: number;
}) {
  return (
    <div>
      <div className={"ui progress " + (percentage >= 100 ? "green" : "blue")}>
        <div
          className="bar"
          style={{
            transitionDuration: "300ms",
            width: percentage + "%",
          }}
        >
          {(() => {
            if (percentage >= 100) {
              return (
                <div
                  className="progress message"
                  style={{ left: "0em", marginLeft: "10px" }}
                >
                  Success!
                </div>
              );
            } else {
              return <div className="progress message">{percentage + "%"}</div>;
            }
          })()}
        </div>
        <div className="label" style={{ color: "#999999", marginTop: "20px" }}>
          {label}
        </div>
      </div>
    </div>
  );
}

export default ProgressUploader;
